import classNames from 'classnames';
import * as React from 'react';
const ThemeContainer = (props) => {
    const { theme, className, children, ...rest } = props;
    const classes = classNames(className, {
        'ixu-cascading-theme-issuu': theme === 'issuu',
        'ixu-cascading-theme-positive': theme === 'positive',
        'ixu-cascading-theme-danger': theme === 'danger',
        'ixu-cascading-theme-prompt': theme === 'prompt',
    });
    return (React.createElement("div", { className: classes, ...rest }, children));
};
ThemeContainer.displayName = 'ThemeContainer';
export default ThemeContainer;
//# sourceMappingURL=ThemeContainer.js.map